import { transformConstants } from 'helpers/transformConstants';

const paymentConfigurationConstants = transformConstants([
  'MOKAPOS_PAYMENT_CONFIGURATION_SAVE',
]);

export { paymentConfigurationConstants };
